exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d2-crud .d2-crud-header[data-v-4ed6cf3d]{border-bottom:1px dotted rgba(0,0,0,.2)}.d2-crud .d2-crud-body[data-v-4ed6cf3d]{padding:15px 0;overflow:hidden}.d2-crud .d2-crud-pagination[data-v-4ed6cf3d]{padding:15px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ed6cf3d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/hb-crud.vue
// module id = 10
// module chunks = 0